/**
 * Universal Table Sorting and Search
 *
 * Automatically adds sorting functionality to any table with sortable headers.
 * Also provides search functionality that searches through data attributes and visible text.
 * Usage: Add class="sortable" and data-column="column_name" to <th> elements
 * Add corresponding data-* attributes to <tr> elements
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all tables with sortable headers
  const tables = document.querySelectorAll('table');

  tables.forEach(table => {
    const headers = table.querySelectorAll('th.sortable');
    if (headers.length === 0) return; // Skip tables without sortable headers

    const tbody = table.querySelector('tbody');
    if (!tbody) return;

    let currentSort = { column: null, direction: 'asc' };

    headers.forEach(header => {
      header.addEventListener('click', function() {
        const column = this.dataset.column;
        const direction = (currentSort.column === column && currentSort.direction === 'asc') ? 'desc' : 'asc';

        sortTable(tbody, column, direction);
        updateSortIcons(headers, this, direction);

        currentSort = { column, direction };
      });
    });
  });

  function sortTable(tbody, column, direction) {
    const rows = Array.from(tbody.querySelectorAll('tr'));

    rows.sort((a, b) => {
      let aVal = a.dataset[column] || '';
      let bVal = b.dataset[column] || '';

      // Auto-detect numeric values
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        // Numeric sorting
        return direction === 'asc' ? aNum - bNum : bNum - aNum;
      } else {
        // String sorting
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();

        if (aVal < bVal) return direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return direction === 'asc' ? 1 : -1;
        return 0;
      }
    });

    rows.forEach(row => tbody.appendChild(row));
  }

  function updateSortIcons(headers, clickedHeader, direction) {
    // Reset all icons
    headers.forEach(h => {
      const icon = h.querySelector('i');
      if (icon) {
        icon.className = 'fas fa-sort text-muted ms-1';
        icon.style.opacity = '0.3';
      }
    });

    // Update clicked header icon
    const icon = clickedHeader.querySelector('i');
    if (icon) {
      icon.className = `fas fa-sort-${direction === 'asc' ? 'up' : 'down'} text-primary ms-1`;
      icon.style.opacity = '1';
    }
  }

  // Universal Table Search
  // Automatically hooks into search inputs and filters table rows
  const searchInputs = document.querySelectorAll('input[type="search"], input[name="search"]');

  searchInputs.forEach(searchInput => {
    const form = searchInput.closest('form');
    const table = document.querySelector('table tbody');

    if (!table) return;

    // Store original rows for filtering
    const allRows = Array.from(table.querySelectorAll('tr'));

    // Add input event listener for real-time search
    searchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();

      if (query === '') {
        // Show all rows when search is empty
        allRows.forEach(row => row.style.display = '');
        updateResultsCount(allRows.length, '');
        return;
      }

      let visibleCount = 0;
      allRows.forEach(row => {
        let found = false;

        // Search through all data attributes
        for (const value of Object.values(row.dataset)) {
          if (value && value.toLowerCase().includes(query)) {
            found = true;
            break;
          }
        }

        // If not found in data attributes, search visible text content
        if (!found) {
          const textContent = row.textContent.toLowerCase();
          if (textContent.includes(query)) {
            found = true;
          }
        }

        row.style.display = found ? '' : 'none';
        if (found) visibleCount++;
      });

      updateResultsCount(visibleCount, query);
    });

    // Prevent form submission to avoid server-side search
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        // Trigger input event to apply current search
        searchInput.dispatchEvent(new Event('input'));
      });
    }
  });

  // Helper function to update results count display
  function updateResultsCount(count, query) {
    // Find the results count text element - look for the specific pattern
    const countElements = document.querySelectorAll('.text-muted');
    let countElement = null;

    for (const element of countElements) {
      if (element.textContent.includes('total') || element.textContent.includes('result')) {
        countElement = element;
        break;
      }
    }

    if (!countElement) return;

    // Extract entity name from the original text (e.g., "users", "events", etc.)
    const originalText = countElement.textContent;
    const entityMatch = originalText.match(/(\d+)\s+total\s+(\w+)/);
    const entityName = entityMatch ? entityMatch[2] : 'results';

    if (query) {
      countElement.textContent = `Showing ${count} result${count !== 1 ? 's' : ''} for "${query}"`;
    } else {
      countElement.textContent = `${count} total ${entityName}`;
    }
  }
});